/**
 * Upload a blob to S3 using XMLHttpRequest
 * This works in both main thread and worker context (no process.env dependency)
 */
const uploadBlobToS3 = (blob, presignedUrl) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        
        xhr.addEventListener('load', () => {
            if (xhr.status === 200) {
                resolve()
            } else {
                reject(new Error(`Upload failed with status ${xhr.status}`))
            }
        })
        
        xhr.addEventListener('error', () => {
            reject(new Error('Network error during upload'))
        })
        
        xhr.addEventListener('timeout', () => {
            reject(new Error('Upload timeout'))
        })
        
        xhr.open('PUT', presignedUrl, true)
        xhr.setRequestHeader('Content-Type', blob.type || 'image/png')
        xhr.timeout = 120000 // 2 minutes
        xhr.send(blob)
    })
}

/**
 * Upload sides to S3 using fetch API (sync/fallback method)
 * 
 * @param {Array} sidesData - [{blob: Blob, presignedUrl: string, side: string}, ...]
 * @returns {Promise<Array>} Array of final URLs
 */
const captureUploadImages = async (sidesData = []) => {
    const uploadResults = await Promise.all(
        sidesData.map(async ({blob, presignedUrl, side}, index) => {
            try {
                // Use XMLHttpRequest upload (works in worker)
                await uploadBlobToS3(blob, presignedUrl)
                
                // Remove query params to get final URL
                const finalUrl = presignedUrl.split('?')[0]
                
                return {
                    side,
                    url: finalUrl,
                    success: true
                }
            } catch (error) {
                return {
                    side,
                    url: null,
                    success: false,
                    error: error.message
                }
            }
        })
    )
    
    return uploadResults
}

export default captureUploadImages
